import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import React from 'react';
import { useIntl } from 'react-intl';

export default function ModalWarningPackage({ isOpen, setIsOpen, data }) {
    const intl = useIntl();

    const onHideDialogDoc = () => {
        setIsOpen(false);
    };

    const dialogFooter = (
        <React.Fragment>
            <Button
                label={intl.formatMessage({ id: 'closepopup' })}
                icon="pi pi-times"
                onClick={onHideDialogDoc}
                className="p-button p-component p-button-raised p-button-danger p-mt-2 w-xs-50 w-lg-auto p-d-xs-block p-d-lg-inline p-mx-auto"
            />
        </React.Fragment>
    );

    const genderInfo = () => {
        const arrayCheck = [];
        if (data?.checkSizeDoc) {
            const str = intl.formatMessage({ id: 'common.numberOfDocumentContract' });
            const strFull = +data?.checkSizeDocFull
                ? intl.formatMessage({ id: 'common.isOver' })
                : intl.formatMessage({ id: 'common.almostOver' });
            const endStr = str + ' ' + strFull;
            arrayCheck.push(endStr);
        }
        if (data?.checkSizeCapacity) {
            const str = intl.formatMessage({ id: 'common.storageCapacity' });
            const strFull = +data?.checkSizeCapacityFull
                ? intl.formatMessage({ id: 'common.isOver' })
                : intl.formatMessage({ id: 'common.almostOver' });
            const endStr = str + ' ' + strFull;

            arrayCheck.push(endStr);
        }
        if (data?.checkSizeProcedure) {
            const str = intl.formatMessage({ id: 'common.numberOfProcess' });
            const strFull = +data?.checkSizeProcedureFull
                ? intl.formatMessage({ id: 'common.isOver' })
                : intl.formatMessage({ id: 'common.almostOver' });
            const endStr = str + ' ' + strFull;
            arrayCheck.push(endStr);
        }
        if (data?.checkSizeUser) {
            const str = intl.formatMessage({ id: 'common.numberOfUser' });
            const strFull = +data?.checkSizeUserFull
                ? intl.formatMessage({ id: 'common.isOver' })
                : intl.formatMessage({ id: 'common.almostOver' });
            const endStr = str + ' ' + strFull;
            arrayCheck.push(endStr);
        }

        return (
            <>
                <span>{intl.formatMessage({ id: 'common.warning' })} </span>
                <span className="label-bold text-primary">{arrayCheck.join('; ')}</span>
            </>
        );
    };

    return (
        <div>
            <Dialog
                visible={isOpen}
                header={intl.formatMessage({ id: 'notify' })}
                modal
                className="p-dialog-default p-dialog-lg font-size-16"
                footer={dialogFooter}
                onHide={onHideDialogDoc}
            >
                <div className="p-text-center">
                    <div>
                        <i className="pi pi-exclamation-triangle font-size-30 text-warning"></i>
                    </div>
                    <div>{genderInfo()}</div>
                    <div>{intl.formatMessage({ id: 'common.pleaseExtendService' })}.</div>
                </div>
            </Dialog>
        </div>
    );
}
